<script>
	import { fade } from 'svelte/transition'
	import { cubicOut } from 'svelte/easing'
	import { text_entered, text_previewed, text_caseapplied, selected_text_case, previews_are_highlighted, hero_expanded } from './../stores.js'
	import { toTitleCase } from './../modules/toTitleCase.js'
  import { createEventDispatcher } from 'svelte'
  import TextCaseSelectButton from './TextCaseSelectButton.svelte'
  
  const dispatch = createEventDispatcher()
  let button_text_cases = ['aa', 'Aa', 'AA']

	$: $selected_text_case !== undefined && applySelectedCase()
	$: $selected_text_case === undefined && resetSelectedCase()

	async function applySelectedCase() {
		if ($selected_text_case === 'AA') {
			$text_caseapplied = $text_entered.toUpperCase()
		}
		else if ($selected_text_case === 'aa') {
			$text_caseapplied = $text_entered.toLowerCase()
		}
		else if ($selected_text_case === 'Aa') {
			$text_caseapplied = toTitleCase($text_entered)
		}
		$text_previewed = $text_caseapplied
		$previews_are_highlighted = false
	}

	async function resetSelectedCase() {
		$text_caseapplied = $text_entered
		$text_previewed = $text_caseapplied
	}
  
</script>

{#if !$hero_expanded}
	<div in:fade="{{ duration: 500, easing: cubicOut }}">
		{#each button_text_cases as button_text_case, i}
			{#if i > 0}
					<span>&nbsp;/</span>
			{/if}
			<TextCaseSelectButton {button_text_case} >
				{button_text_case}
			</TextCaseSelectButton>
		{/each}
	</div>
{/if}

<style>
  div {
		position: absolute;
  	top: 0;
  	right: 1rem;
    font-family: var(--Lucida);
    font-size: 1.5rem;
    font-weight: normal;
    color: var(--c-text-faded);
  }
</style>